//
//
//
//
//
//

import wx from 'weixin-js-sdk'; 

export default {
  name: 'openMap',
  components: {
  },
  data () {
    return {
      id:0,
      info:{}
    }
  },
  created(){
    this.id = Number(this.$route.params.id);
    console.log(this.id);
    this.config();
  },
  methods:{
  
  }
}



// WEBPACK FOOTER //
// ./src/pages/openMap.vue